export default __webpack_public_path__ + "static/media/Connecticut3Open.cbd836b2.jpg";